/**
 * Comercial → Empresas (issue #115).
 *
 * Empresas da organização (`crm.companies`) — as importadas pela
 * Prospecção (base pública de CNPJ) e as criadas à mão. Busca por nome,
 * razão social ou CNPJ; a linha abre o detalhe em `/comercial/empresas/:id`
 * (EmpresaView).
 */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout.jsx'
import Icon from '../../components/icons.jsx'
import { getCompanies } from '../../db/api.js'
import './clientes.css'
import './empresas.css'

export const SITUACOES = [
  { value: 'ativa', label: 'Ativa' },
  { value: 'baixada', label: 'Baixada' },
  { value: 'suspensa', label: 'Suspensa' },
  { value: 'inapta', label: 'Inapta' },
  { value: 'nula', label: 'Nula' },
]

export const fmtCnpj = (v) => {
  const d = String(v || '').replace(/\D/g, '')
  return d.length === 14
    ? `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
    : v
}

const SITUACAO_LABEL = Object.fromEntries(SITUACOES.map((s) => [s.value, s.label]))

export default function Empresas() {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [rows, setRows] = useState(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    let alive = true
    const timer = setTimeout(() => {
      getCompanies(search.trim(), 200)
        .then((data) => { if (alive) { setRows(Array.isArray(data) ? data : data.items || []); setErr('') } })
        .catch((e) => { if (alive) setErr(e.message) })
    }, 250)
    return () => { alive = false; clearTimeout(timer) }
  }, [search])

  return (
    <Layout title="Empresas" breadcrumb={[{ label: 'Comercial' }, { label: 'Empresas' }]}>
      {err && <div className="cl-error">{err}</div>}
      <div className="cl-card">
        <div className="cl-filters">
          <div className="cl-search">
            <span className="cl-search-icon"><Icon n="search" s={16} /></span>
            <input placeholder="Buscar por nome, razão social ou CNPJ" value={search}
              onChange={(e) => setSearch(e.target.value)} aria-label="Buscar empresa" />
          </div>
        </div>
        {rows === null ? (
          <div className="cl-state">Carregando…</div>
        ) : !rows.length ? (
          <div className="cl-state">
            {search ? 'Nenhuma empresa encontrada.' : 'Nenhuma empresa na organização ainda. Importe pela Prospecção.'}
          </div>
        ) : (
          <div className="cl-table-scroll">
            <table className="cl-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Razão social</th>
                  <th>CNPJ</th>
                  <th>Cidade/UF</th>
                  <th>Situação</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((co) => (
                  <tr key={co.id} tabIndex={0} onClick={() => navigate(`/comercial/empresas/${co.id}`)}
                    onKeyDown={(e) => { if (e.key === 'Enter') navigate(`/comercial/empresas/${co.id}`) }}>
                    <td>{co.nome}</td>
                    <td>{co.razao_social || '—'}</td>
                    <td>{co.cnpj ? fmtCnpj(co.cnpj) : '—'}</td>
                    <td>{[co.cidade, co.estado].filter(Boolean).join(' / ') || '—'}</td>
                    <td>{SITUACAO_LABEL[co.situacao_cadastral] || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {rows?.length === 200 && <div className="cl-state">Mostrando as 200 primeiras. Use a busca para achar as demais.</div>}
      </div>
    </Layout>
  )
}
